module.exports = __webpack_public_path__ + "static/wireframe-online-banking-app-mobile-plp-0caf534f5757fea6fd8ea1ba8f0a68c9.png";